import { useMemo, useState } from "react";
import type { QueueItem } from "../lib/api";
import { Thumb } from "./Thumb";

// Picking builds for a settlement. Multi-select with pictures, because at this
// point the question is "which of these belong together", and a list of file
// names cannot answer it.

export function AddMembers(props: {
  items: QueueItem[];
  // Builds that are already in some settlement: shown, but not offered twice.
  taken: Set<number>;
  role: number;
  onClose: () => void;
  onAdd: (ids: number[]) => void;
}) {
  const [q, setQ] = useState("");
  const [chosen, setChosen] = useState<Set<number>>(new Set());

  const shown = useMemo(() => {
    const needle = q.trim().toLowerCase();
    return props.items.filter(
      (i) =>
        !props.taken.has(i.id) &&
        (!needle ||
          i.name.toLowerCase().includes(needle) ||
          i.folder.toLowerCase().includes(needle)),
    );
  }, [props.items, props.taken, q]);

  const toggle = (id: number) =>
    setChosen((c) => {
      const n = new Set(c);
      if (n.has(id)) n.delete(id);
      else n.add(id);
      return n;
    });

  return (
    <div className="modal" onClick={props.onClose}>
      <div className="sheet wide" onClick={(e) => e.stopPropagation()}>
        <h2>
          {props.role === 1 ? "Anker wählen" : "Mitglieder hinzufügen"}
          <button className="linkish" onClick={props.onClose}>
            schließen
          </button>
        </h2>
        <input
          autoFocus
          type="search"
          placeholder="Name oder Ordner suchen…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
        <div className="pickgrid">
          {shown.map((i) => (
            <button
              key={i.id}
              type="button"
              className={chosen.has(i.id) ? "pick chosen" : "pick"}
              onClick={() => toggle(i.id)}
            >
              <Thumb id={i.id} />
              <span className="name">{i.name}</span>
              <span className="where">{i.folder}</span>
            </button>
          ))}
          {shown.length === 0 && (
            <p className="hint">
              Nichts frei — was schon in einer Siedlung steht, wird hier nicht
              angeboten.
            </p>
          )}
        </div>
        <div className="actions">
          <button
            className="primary"
            disabled={chosen.size === 0}
            onClick={() => props.onAdd([...chosen])}
          >
            {chosen.size === 0
              ? "nichts gewählt"
              : `${chosen.size} übernehmen`}
          </button>
          <button onClick={props.onClose}>abbrechen</button>
        </div>
      </div>
    </div>
  );
}
